import { useEffect, useState } from 'react'
import styled from 'styled-components'

const STARTUP_CONNECTION_REMINDER_DELAY_MS = 8000

const ReminderLine = styled.div<{ $textColor?: string }>`
  color: ${({ $textColor }) => $textColor ?? 'inherit'};
  font-size: 0.35rem;
  line-height: 150%;
  text-align: center;
  white-space: nowrap;
`

const SwitchButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  color: #0051ff;
  font: inherit;
  padding: 0;
  text-decoration: underline;
  text-shadow: inherit;
`

interface StartupConnectionReminderInlineTriggerProps {
  active: boolean
  onOpen: () => void
  textColor?: string
}

export default function StartupConnectionReminderInlineTrigger({
  active,
  onOpen,
  textColor,
}: StartupConnectionReminderInlineTriggerProps) {
  const [reminderVisible, setReminderVisible] = useState(false)

  useEffect(() => {
    if (!active) {
      setReminderVisible(false)
      return
    }

    const id = setTimeout(() => {
      setReminderVisible(true)
    }, STARTUP_CONNECTION_REMINDER_DELAY_MS)

    return () => clearTimeout(id)
  }, [active])

  if (!reminderVisible) return null

  return (
    <ReminderLine $textColor={textColor}>
      <span>網絡開小差，</span>
      <SwitchButton type="button" onClick={onOpen}>
        去切換
      </SwitchButton>
    </ReminderLine>
  )
}
